export default __webpack_public_path__ + "static/201-adb4c56c51a7e202d711f29b13f86447.jpg";